import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockAlignSchema,
  TopolBlockSchema,
  TopolColorSchema,
} from "../commonSchema";

const defaults = {
  padding: "15px 15px 15px 15px",
  "line-height": 1.5,
  containerWidth: 600,
};

export const TopolTextBlockAttributesBasicSchema = z.object({
  align: TopolBlockAlignSchema.optional(),
  padding: z.string(),
  "line-height": z.union([z.string(), z.number()]),
  containerWidth: z.number(),
  "css-class": TopolBlockCssClassSchema.optional(),
  color: TopolColorSchema.optional().catch(undefined),
  "font-size": z.string().optional().catch(undefined),
  "font-family": z.string().optional().catch(undefined),
  "container-background-color": TopolColorSchema.optional().catch(undefined),
});

export const TopolTextBlockAttributesSchema =
  TopolTextBlockAttributesBasicSchema.extend({
    padding: z.string().catch(defaults.padding),
    "line-height": z
      .union([z.string(), z.number()])
      .catch(defaults["line-height"]),
    containerWidth: z.number().catch(defaults.containerWidth),
  });

export const TopolTextBlockStyleAttributesSchema =
  TopolTextBlockAttributesSchema.omit({
    align: true,
    "line-height": true,
    containerWidth: true,
    "css-class": true,
    color: true,
    "font-size": true,
    "font-family": true,
    "container-background-color": true,
  });

export type TopolTextBlockAttributes = z.infer<
  typeof TopolTextBlockAttributesSchema
>;

export const TopolTextBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-text"),
  attributes: TopolTextBlockAttributesSchema.catch(defaults),
  content: z.string().catch(""),
});

export type TopolTextBlock = z.infer<typeof TopolTextBlockSchema>;
